import {Component} from 'react';
import {doubleToStringMonthly, standardNumberFormat} from '../../objects/CommonUse/double_functions';
import { reformatDateToDisplay } from '../../objects/CommonUse/reformatDateToDisplay_function';

class ThreeColumnTableCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, selected: false};
    }

    reformatInput(){
        if (this.props.outInfo.amount1){
            if (this.props.outInfo.amount1 === ""){
                this.amount1 = "---";
            }else{
                this.amount1 = doubleToStringMonthly(this.props.outInfo.amount1);
            }
        }
        if (this.props.outInfo.amount2 || this.props.outInfo.amount2 === 0){
            if (this.props.outInfo.amount2 === ""){
                this.amount2 = "---";
            }else{
                this.amount2 = doubleToStringMonthly(this.props.outInfo.amount2);
            }
        }
        switch (this.props.infoType){
              case "date-amount-string":
                  this.outField1 = reformatDateToDisplay(this.props.outInfo.date);
                  this.outField2 = doubleToStringMonthly(this.props.outInfo.amount);
                  this.outField3 = this.props.outInfo.string;
                  this.rowClass = "";
                  if (this.props.outInfo.highlightRow === true){
                    this.rowClass = "table-primary";
                  }
                  break;
              case "date-amount-amount":
                  this.reformatStartDate = reformatDateToDisplay(this.props.outInfo.startDate);
                  this.reformatEndDate = reformatDateToDisplay(this.props.outInfo.endDate);
                  break;
              case "label-date-amount":
                  this.class = "text-left p-0 ";
                  if (this.props.outInfo.class){
                       this.class = this.class + this.props.outInfo.class;
                  }
                  this.reformatEndDate = reformatDateToDisplay(this.props.outInfo.endDate);
                  break;
               case "label-quantity-amount":
                  this.class = "text-left p-0 ";
                  if (this.props.outInfo.class){
                       this.class = this.class + this.props.outInfo.class;
                  }
                  if (isNaN(+this.props.outInfo.quantity)){
                    this.quantity = standardNumberFormat(this.props.outInfo.quantity);
                  }else{
                    this.quantity = this.props.outInfo.quantity;
                  }
                  break;
              case "label-amount-amount":
                   this.labelClass = "text-left p-0 ";
                   if (this.props.labelClass){
                        this.labelClass += this.props.labelClass;
                   }
                   if (!this.props.className){
                        this.className1 = "p-0 text-right";
                        this.className2 = "p-0 text-right";
                   }else{ 
                        this.className1 = this.props.className;
                        this.className2 = this.props.className;
                   } 
                   if (this.props.outInfo.color1 === "red"){
                        this.className1 = this.className1 + " text-danger";
                   }
                   if (this.props.outInfo.color2 === "red"){
                        this.className2 = this.className2 + " text-danger";
                   }
                   break;
                case "label-label-label":
                    if (this.props.column1Class){
                        this.class = this.props.column1Class;
                    }else{
                        this.class = "text-center p-0";
                    }
                    break;
                default: 
                   break;
            }
    }
    render() {
        this.reformatInput(); 
    return <>
       {this.props.infoType === "label-date-amount" ?
            <tr>
              <td className="text-left p-0">{this.props.outInfo.label}</td>
              <td className="p-0 text-right">{this.reformatEndDate}</td>
              <td className="p-0 text-right">{this.amount1}</td>
            </tr>
       :
            null
       }
       {this.props.infoType === "date-amount-amount"  ?
            <tr>
              <td className={this.class}>{this.reformatStartDate}-{this.reformatEndDate}</td>
              <td className="p-0 text-right">{this.amount1}</td>
              <td className="p-0 text-right">{this.amount2}</td>
            </tr>
       :
          null
       }
       {this.props.infoType === "label-quantity-amount"  ?
            <tr>
              <td className={this.class}>{this.props.outInfo.label}</td>
              <td className="p-0 text-right">{this.quantity}</td>
              <td className="p-0 text-right">{this.amount1}</td>
            </tr>
       :
          null
       }
       {this.props.infoType === "label-amount-amount" ?
          <tr>
              <td className={this.labelClass}>{this.props.outInfo.label}</td>
              <td className={this.className1}>{this.amount1}</td>
              <td className={this.className2}>{this.amount2}</td>
          </tr>
       :
          null
       }
       {this.props.infoType === "label-label-label" ?
            <tr>
                <td className={this.class}>{this.props.outInfo.label1}</td>
                <td className="text-center p-0">{this.props.outInfo.label2}</td>
                <td className="text-center p-0">{this.props.outInfo.label3}</td>
            </tr> 
        :
            null  
        }

        {this.props.infoType === "date-amount-string" ?
            <tr className={this.rowClass}>
                <td className="text-center p-0">{this.outField1}</td>
                <td className="text-center p-0">{this.outField2}</td>
                <td className="text-center p-0">{this.outField3}</td>
            </tr>
        :
            null
        }
        
        
    </>
    }
}

export default ThreeColumnTableCard;